export default __webpack_public_path__ + "static/media/POMINA.aaacf593.png";